import { DataPublishOptions, Room } from 'livekit-client'

export const handlePublishData = async (
  room: Room,
  msg: string | Record<string, unknown>,
  options: DataPublishOptions = {},
) => {
  if (!room) return

  const textEncoder = new TextEncoder()
  let encodedMessage: Uint8Array

  if (typeof msg === 'string') {
    encodedMessage = textEncoder?.encode(msg)
  } else {
    encodedMessage = textEncoder?.encode(JSON.stringify(msg))
  }

  return await room?.localParticipant?.publishData(encodedMessage, {
    ...options,
  })
}
